<template>
    <div class="xx-dashboard" v-loading="loading">
        <el-row v-for="(item, index) in innerList" :key="index">
            <el-col v-for="(item2, index2) in item" :key="index2" :span="span">
                <div class="item-wrap">
                    <div class="item-label" :style="{ width: `${item2.labelWidth}px` }">{{ item2.label }}</div>
                    <div class="item-value">
                        <div v-if="loading"></div>
                        <div v-else>
                            <slot :name="item2.slot" v-if="item2.slot"></slot>
                            <span v-else>{{ item2.value }}</span>
                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import chunk from 'lodash/chunk';
import { get, getLabelByValue, formatTime, isEmptyObject, range } from '@lsfe/tools';

export default {
    name: 'XxDashboard',
    props: {
        /**
         * 数据源
         * @type {Object}
         */
        data: {
            type: Object,
            default: () => {
                return {};
            }
        },
        /**
         * 配置项
         * @type {Array}
         *
         * [
         *     {
         *         label: String,
         *         prop: String,
         *         slot: String, // 可选
         *     }
         * ]
         */
        config: {
            type: Array,
            required: true
        },
        /**
         * 列数
         * @type {Number}
         */
        column: {
            type: Number,
            default: 3
        },
        /**
         * 标签的后缀
         * @type {String}
         */
        labelSuffix: {
            type: String,
            default: ' '
        }
    },
    computed: {
        loading() {
            return isEmptyObject(this.data);
        },
        innerList() {
            const { column } = this;
            const list = this.getInnerData();
            return chunk(list, column);
        },
        span() {
            const { column } = this;
            return 24 / column;
        }
    },
    methods: {
        getInnerData() {
            const { data, config, labelSuffix, column } = this;
            return config.map((v, i) => {
                const { label, prop, slot, template = {} } = v;
                const { tpl = '' } = template;

                let value = get(data, prop, '--');

                // 枚举
                if (tpl === 'enum' && template.list) {
                    value = getLabelByValue(value, template.list);
                }
                // 时间
                if (tpl === 'datetime') {
                    value = formatTime(value, template.format || 'YYYY-MM-DD');
                }

                const renderLabel = `${label}${labelSuffix}`;

                const columnList = config.filter((v2, i2) => {
                    return range(i % column, config.length, column).includes(i2);
                });

                const labelWidth = Math.max(
                    ...columnList
                        .map(v => {
                            return (v.label || '').length;
                        })
                        .map(v => {
                            return (v + 1) * 14;
                        })
                );

                return {
                    label: renderLabel,
                    labelWidth,
                    value,
                    slot
                };
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.xx-dashboard {
    .item-wrap {
        display: flex;
    }
    .item-label {
        color: #777;
    }
    .item-value {
        flex: 1;
    }
}
</style>
